/* import __COLOCATED_TEMPLATE__ from './vet-service-project-digest-card.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { isUrl } from 'sh-www/utils/misc';
import { action } from '@ember/object';
import { showModal } from 'sh-www/utils/modal-controls';
import {
  PROJECTDIGEST_VERIFICATION_STATUS,
  PROJECTDIGEST_VERIFICATION_METHODS,
} from 'sh-www/models/projectdigest-verification';
import clsx from 'clsx';

import { INPUT_FIELDS } from 'sh-www/components/lsg/lsg-decimal-input';

const CLASS_NAME = 'SH-c-admin-vet-service-projectdigest';

class VetServiceProjectDigestCardComponent extends Component {
  @tracked hasThumbnailFailed = false;
  @tracked hasThumbnailLoaded = false;

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get inputFieldWhole() {
    return INPUT_FIELDS.WHOLE;
  }

  get inputFieldDecimal() {
    return INPUT_FIELDS.DECIMAL;
  }

  get submittedAt() {
    const date = this.args.projectDigest.createdAt;
    return this.args.moment.moment(date).format('MM/DD/YYYY');
  }

  /** @type {String} */
  get completedAt() {
    const date = this.args.projectDigest.application.completedAt;
    return date
      ? this.args.moment.moment(date).format('MM/DD/YYYY')
      : '';
  }

  get thumbnailUrl() {
    const projectDigest = this.args.projectDigest;
    const thumbnail = projectDigest.thumbnailUrl;

    if (thumbnail) {
      return thumbnail;
    }

    const link = projectDigest.link;

    if (!link || !isUrl(link)) {
      return '';
    }

    return this.args.onGetThumbnail(link);
  }

  get hasVisibleThumbnail() {
    if (this.hasThumbnailFailed) return false;

    return this.thumbnailUrl && this.hasThumbnailLoaded;
  }

  get isShowingVerificationButtons() {
    const { projectDigest } = this.args;
    return Boolean(
      !projectDigest.confirm
      && projectDigest.mostRecentProjectDigestVerification
      && projectDigest.mostRecentProjectDigestVerification.method !== PROJECTDIGEST_VERIFICATION_METHODS.REFERRAL
    );
  }

  @action
  onSetServiceRating(serviceId, digestId, inputName, rating) {
    if (INPUT_FIELDS.WHOLE === inputName && !rating) {
      this.args.handleClearServiceRating('serviceRatings', serviceId, digestId);
      return;
    }

    this.args.handleSetServiceRating('serviceRatings', serviceId, inputName, rating, digestId);
  }

  @action
  handleThumbnailError() {
    this.hasThumbnailFailed = true;
  }

  @action
  handleThumbnailLoad() {
    this.hasThumbnailLoaded = true;
  }

  @action
  handleThumbnailClick() {
    const projectDigest = this.args.projectDigest;

    this.args.onOpenVideoPlayer(projectDigest);
  }

  @action
  handleCopyLink() {
    navigator.clipboard.writeText(this.args.projectDigest.link)
      .then(() => this.args.onAddToast('Link copied to clipboard'))
      .catch(() => this.args.onAddToast('Failed to copy link'));
  }

  @action
  handleBadLinkClicked() {
    const { setBadLink, projectDigest } = this.args;
    showModal(this, 'confirmation',  {
      titleText: 'Does this work sample have a broken link?',
      bodyText: 'The creator will be notified via email.',
      actionButtonText: 'Confirm',
      confirmAction: () => {
        setBadLink.perform(projectDigest.id);
      },
      cancelButtonText: 'Cancel',
    });
  }

  @action
  onVerifyClicked() {
    const { setVerificationStatus, projectDigest } = this.args;

    showModal(this, 'confirmation',  {
      titleText: 'Verify Work Sample',
      bodyText: 'Are you sure you want to verify this work sample?',
      actionButtonText: 'Confirm',
      confirmAction: () => {
        setVerificationStatus.perform(
          projectDigest.mostRecentProjectDigestVerification.id,
          projectDigest.id,
          PROJECTDIGEST_VERIFICATION_STATUS.VERIFIED
        );
      },
      cancelButtonText: 'Cancel',
    });
  }

  @action
  onUnableToVerifyClicked() {
    const { setVerificationStatus, projectDigest } = this.args;
    showModal(this, 'confirmation',  {
      titleText: 'Cannot Verify',
      bodyText: 'Do you want to notify the creator that you could not verify this work sample using their provided method?',
      actionButtonText: 'Confirm',
      confirmAction: () => {
        setVerificationStatus.perform(
          projectDigest.mostRecentProjectDigestVerification.id,
          projectDigest.id,
          PROJECTDIGEST_VERIFICATION_STATUS.CANNOT_VERIFY
        );
      },
      cancelButtonText: 'Cancel',
    });
  }
}

export default VetServiceProjectDigestCardComponent;
